import {
  HorizontalTabTypes,
  SelectedTabIconColors,
} from '../constants';
import { IconColors } from '../../icon';
import Typography from '../../typography';

export const checkTabBorderLess = (type, expanded, hasParent) => {
  if (expanded) {
    return false;
  }

  if (hasParent) {
    return true;
  }

  return type !== HorizontalTabTypes.PRIMARY_TAB && type !== HorizontalTabTypes.PRIMARY_PILL_TAB;
};

export const getTabsParentClass = (type, hasChildren) => {
  let parentClass = 'ctc-tabs-wrapper';

  if (hasChildren) {
    switch (type) {
      case HorizontalTabTypes.TEXT_TAB:
      case HorizontalTabTypes.SECONDARY_TAB:
        parentClass += ' secondary';
        break;

      case HorizontalTabTypes.PRIMARY_TAB:
      case HorizontalTabTypes.TERTIARY_TAB:
      case HorizontalTabTypes.PRIMARY_PILL_TAB:
        parentClass += ' primary';
        break;

      default:
        break;
    }
  }

  return parentClass;
};

export const getLabelColor = (type, selected, borderLess, hasParent) => {
  switch (type) {
    case HorizontalTabTypes.TEXT_TAB:
    case HorizontalTabTypes.TERTIARY_TAB:
      if (selected) {
        return Typography.Colors.primary700;
      }
      return Typography.Colors.gray500;
    case HorizontalTabTypes.SECONDARY_TAB:
      if (selected) {
        return Typography.Colors.gray700;
      }
      return Typography.Colors.gray500;
    case HorizontalTabTypes.PRIMARY_TAB:
      if (!borderLess) {
        return Typography.Colors.primary700;
      }

      if (hasParent && !selected) {
        return Typography.Colors.gray500;
      }
      return Typography.Colors.white;
    case HorizontalTabTypes.PRIMARY_PILL_TAB:
      if (!borderLess) {
        return Typography.Colors.primary700;
      }
      if (hasParent) {
        if (selected) {
          return Typography.Colors.primary700;
        }
        return Typography.Colors.gray500;
      }
      return Typography.Colors.white;

    default:
      return Typography.Colors.gray500;
  }
};

export const getIconColor = (type, selected, isGrouped, hasParent, expanded) => {
  if (isGrouped) {
    if (expanded) {
      if (hasParent) {
        if (selected) {
          return IconColors.PRIMARY;
        }
        return IconColors.GREY;
      }
      return IconColors.LIGHT;
    }
    return IconColors.PRIMARY;
  }

  return SelectedTabIconColors[type];
};
